import { render, staticRenderFns } from "./productPage.vue?vue&type=template&id=6de07197&scoped=true"
import script from "./productPage.vue?vue&type=script&lang=js"
export * from "./productPage.vue?vue&type=script&lang=js"
import style0 from "./productPage.vue?vue&type=style&index=0&id=6de07197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de07197",
  null
  
)

export default component.exports